import React from "react";
import EntityLink from "../../../shared/EntityLink";

function OrganizationCell({ organization, entityLinkOptions }) {
    return organization ? (
        <EntityLink
            entity={organization}
            options={entityLinkOptions}
            hideAvatar
        />
    ) : (
        "N/A"
    );
}

export default OrganizationCell;
